import {
  Drawer,
  DrawerBody,
  Icon,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
 import { RiMenu4Fill } from "react-icons/ri";

import React from "react";
import Content from "./Component/Content";
import { Flex } from "@chakra-ui/react";
 export function SidebarResponsive({ routes, onLinkClick, activePath }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  document.documentElement.dir = "rtl";
  return (
    <Flex
      display={{ sm: "flex", xl: "none" }}
      style={{
        alignItems: "center",
      }}
    >
      <div ref={btnRef} onClick={onOpen}>
        <Icon className="navIcon" as={RiMenu4Fill} />
      </div>
      <div className="nav-menu">
        <Drawer isOpen={isOpen} onClose={onClose} finalFocusRef={btnRef}>
          <DrawerOverlay />
          <DrawerContent className="sidebar-responsive">
            <DrawerCloseButton
              zIndex="3"
              onClose={onClose}
              _hover={{
                outline: "none !important",
                border: "none !important",
                boxShadow: "none",
              }}
              _focus={{
                outline: "none !important",
                border: "none !important",
                boxShadow: "none",
              }}
            />
            <DrawerBody>
              <Content
                routes={routes}
                onLinkClick={onLinkClick}
                activePath={activePath}
              />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </div>
    </Flex>
  );
}
